//@flow
import React from 'react';
import ProductBasicInfo from '../../ProductDetails/components/ProductBasicInfo.react';
import ItemQtyWrapper from '../../ItemQty/components/ItemQtyWrapper.react';
import AddCartButton from '../../ProductDetails/components/AddCartButton.react';

import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type ProductModel from '../../Stores/Products/productModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  categories:CategoriesCollection,
  product:ProductModel,
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  children:string|React$Node,
  inCheckout?:boolean,
  onAdd?:() => void,
  membershipPlan:MembershipPlanModel,
};

export default function UpsellSnackCard(props:Props){
  return (
    <div className="upsell-snack-card">
      <p className="upsell-tagline">{props.children}</p>
      <img
        className="upsell-snack-img"
        src={props.product.getSnackcardImageUrl(80, 80)}
        alt={props.product.getName()}
      />
      <ProductBasicInfo
        className="upsell-snack-info"
        product={props.product}
        quote={props.quote}
        hideBadge={true}
        categories={props.categories}
        showBasicPrice={true}
        membershipPlan={props.membershipPlan}
      />
      <ItemQtyWrapper
        className="upsell-item-qty"
        displayComponentClass={AddCartButton}
        quoteId={props.quote.getId()}
        sku={props.product.getSku()}
        onAdd={props.onAdd}
        inCheckout={props.inCheckout}
      />
    </div>
  );
}
